import React from 'react';
import { Tag } from '../../../../common/components/v2';
import { TagType } from '../../../../common/components/v2/Tag';

export const RxDetailsSeverity = ({ severity }: { severity: string }) => {
  let type: TagType;
  switch (severity.toUpperCase()) {
    case 'LOW': {
      type = 'green';
      break;
    }
    case 'MEDIUM': {
      type = 'orange';
      break;
    }
    case 'HIGH': {
      type = 'red';
      break;
    }
    default: {
      type = 'gray';
    }
  }
  return <Tag type={type}>{severity}</Tag>;
};
